import { trackEvent } from './segment';

export const trackShowroomFloorTypeSelected = ({
  floorTypeSelected,
  studioId
}) => {
  trackEvent({
    event: 'showroom_floor_type_selected',
    properties: {
      floor_type_selected: floorTypeSelected,
      studio_id: studioId
    }
  });
};

export const trackShowroomWallColorSelected = ({
  wallColorSelected,
  studioId
}) => {
  trackEvent({
    event: 'showroom_wall_color_selected',
    properties: {
      wall_color_selected: wallColorSelected,
      studio_id: studioId
    }
  });
};

export const trackShowroomUpgradeSelected = ({
  studioId,
  upgradeSelected
}) => {
  trackEvent({
    event: 'showroom_upgrade_selected',
    properties: {
      studio_id: studioId,
      upgrade_selected: upgradeSelected
    }
  });
};

export const trackShowroomUpgradeBannerExpanded = ({
  budget,
  numberOfRestyles,
  studioId,
  styleResult
}) => {
  trackEvent({
    event: 'showroom_upgrade_banner_expanded',
    properties: {
      budget,
      number_of_restyles: numberOfRestyles,
      studio_id: studioId,
      style_result: styleResult
    }
  });
};

export const trackShowroomProjectDetailsCompleted = ({
  budget,
  colorPalette,
  studioId
}) => {
  trackEvent({
    event: 'showroom_project_details_completed',
    properties: {
      budget,
      color_palette: colorPalette,
      studio_id: studioId
    }
  });
};

export const trackShowroomPendingDesignsVideoWatched = ({
  budget,
  colorPalette,
  studioId,
  styleResult,
  videoWatched
}) => {
  trackEvent({
    event: 'showroom_pending_designs_video_watched',
    properties: {
      budget,
      color_palette: colorPalette,
      studio_id: studioId,
      style_result: styleResult,
      video_watched: videoWatched
    }
  });
};

export const trackShowroomViewDesigns = ({
  studioId,
  timestamp
}) => {
  trackEvent({
    event: 'showroom_view_designs',
    properties: {
      studio_id: studioId,
      timestamp
    }
  });
};

export const trackShowroomRestyle = ({
  studioId
}) => {
  trackEvent({
    event: 'showroom_restyle',
    properties: {
      studio_id: studioId
    }
  });
};
